import { render, staticRenderFns } from "./PersonalTips.vue?vue&type=template&id=125d0c81&scoped=true&"
import script from "./PersonalTips.vue?vue&type=script&lang=js&"
export * from "./PersonalTips.vue?vue&type=script&lang=js&"
import style0 from "./PersonalTips.vue?vue&type=style&index=0&id=125d0c81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125d0c81",
  null
  
)

export default component.exports